module.exports = "../dist/img/product-card-17.0292.jpg";